var render = function render(_c,_vm){return _c('div',[_c('span',{class:_vm.$options.changeColor(_vm.props)},[_vm._v(" "+_vm._s(_vm.props.rowValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }